import { all, call, put, fork, takeEvery } from "redux-saga/effects";
//import moment from "moment";
import {
  DOCTORS_GET_LIST,
  DOCTOR_GET_DATA,
  DOCTOR_GET_AVATAR,
  DOCTOR_ADD_ITEM,
  DOCTOR_CLEAR_DATA,
} from "../actions";

import {
  getDoctorsListSuccess,
  getDoctorsListError,
  getDoctorDataSuccess,
  getDoctorDataError,
  getDoctorAvatarSuccess,
  getDoctorAvatarError,
  addDoctorItemSuccess,
  addDoctorItemError,
} from "./actions";

//1. Our worker saga

//* this function encode email address (@ is not admitted on backend side)
function getBody(jsondata) {
  var body = [];
  for (var key in jsondata) {
    var encKey = encodeURIComponent(key);
    var encVal = encodeURIComponent(jsondata[key]);
    body.push(encKey + "=" + encVal);
  }
  return body.join("&");
}

//* GET LIST OF THE DOCTORS (ACCESS ADMINS) //--------------------------------------------------------
const getDoctorsListRequest = async (payload) => {
  //console.log(payload.payload);
  let username = payload.payload;

  //console.log("GET LIST OF THE DOCTORS (ACCESS ADMINS)");

  return await fetch(`/mick/doctors/${username}/list?archived=0`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      return data.data;
    });
};

function* getDoctorsList(payload) {
  //payload will be the username from the component
  //console.log(payload);

  try {
    const response = yield call(getDoctorsListRequest, payload);
    yield put(getDoctorsListSuccess(response));
  } catch (error) {
    yield put(getDoctorsListError(error));
  }
}

//* GET DATA DOCTOR  -----------------------------------------------------------------------------
const getDoctorDataRequest = async (payload) => {
  //console.log(payload.payload);
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/info`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    })
    .catch((error) => console.error(error));
};

function* getDoctorData(payload) {
  // payload will be the username from the component
  //console.log(payload);
  try {
    const response = yield call(getDoctorDataRequest, payload);
    //console.log(response);
    yield put(getDoctorDataSuccess(response[0]));
  } catch (error) {
    yield put(getDoctorDataError(error));
  }
}

//* GET AVATAR DOCTOR  ---------------------------------------------------------------------------
const getDoctorAvatarRequest = async (payload) => {
  let username = payload.payload;

  return await fetch(`/mick/doctors/${username}/avatar`, {
    method: "get",
    credentials: "include",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
    },
  }).then((data) => {
    //console.log(data);
    return data;
  });
};

function* getDoctorAvatar(payload) {
  console.log(payload);
  try {
    const response = yield call(getDoctorAvatarRequest, payload);

    if (response.ok) {
      yield put(getDoctorAvatarSuccess(response.url));
    } else {
      yield put(getDoctorAvatarSuccess(""));
    }
  } catch (error) {
    yield put(getDoctorAvatarError(error));
  }
}

//* ADD & ATTACH DOCTOR (ACCESS SUPER ADMIN OR ADMIN)// ----------------------------------------------------------------------------------------------
const addDoctorItemRequest = async (payload) => {
  var {
    //* GENERAL
    email, //string (for sending invitation)

    name, //string
    surname, //string
    language, //string
    affiliation, //string
    specialty, //string
    rank, //string
    gender, //string

    //* FISCAL
    vat, //string
    company, //string
    fiscalCity, //string
    fiscalAddress, //string
    fiscalPostalCode, //string
    fiscalCountry, //string
    fiscalPhone, //numeric

    //* DELIVERY
    deliveryCity, //string
    deliveryAddress, //string
    deliveryCountry, //string
  } = payload;

  if (fiscalPostalCode) {
    fiscalAddress = fiscalAddress + ", " + fiscalPostalCode;
  }

  console.log(
    getBody({
      email,
      name,
      surname,
      language,
      affiliation,
      specialty,
      rank,
      gender,
      vat,
      company,
      fiscalCity,
      fiscalAddress,
      fiscalCountry,
      fiscalPhone,
      deliveryCity,
      deliveryAddress,
      deliveryCountry,
    })
  );

  return await fetch(`/mick/doctors/attach/`, {
    method: "post",
    credentials: "same-origin",
    headers: {
      "Access-Control-Allow-Origin": "https://35.189.226.137",
      //Accept: "application/x-www-form-urlencoded",
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: getBody({
      email,
      name,
      surname,
      language,
      affiliation,
      specialty,
      rank,
      gender,
      vat,
      company,
      fiscalCity,
      fiscalAddress,
      fiscalCountry,
      fiscalPhone,
      deliveryCity,
      deliveryAddress,
      deliveryCountry,
    }),
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* addDoctorItem(payload) {
  //console.log(payload);
  try {
    const response = yield call(addDoctorItemRequest, payload.payload);

    if (!response.includes("ERROR")) {
      yield put(addDoctorItemSuccess(response));
    } else {
      yield put(addDoctorItemError(response));
    }
  } catch (error) {
    yield put(addDoctorItemError(error));
  }
}

//* CLEAR DOCTOR DATA // -------------------------------------------------------------------

function clearDoctorData({ payload }) {
  const { history } = payload;
}

//2. Our watcher saga
// our watcher saga spawn a new task on each action

export function* watchGetDoctorsList() {
  yield takeEvery(DOCTORS_GET_LIST, getDoctorsList);
}
export function* watchGetDoctor() {
  yield takeEvery(DOCTOR_GET_DATA, getDoctorData);
}

export function* watchGetDoctorAvatar() {
  yield takeEvery(DOCTOR_GET_AVATAR, getDoctorAvatar);
}

export function* watchAddDoctor() {
  yield takeEvery(DOCTOR_ADD_ITEM, addDoctorItem);
}

export function* watchClearDoctor() {
  yield takeEvery(DOCTOR_CLEAR_DATA, clearDoctorData);
}

//3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(watchGetDoctorsList),
    fork(watchGetDoctor),
    fork(watchGetDoctorAvatar),
    fork(watchAddDoctor),
    fork(watchClearDoctor),
  ]);
}
